import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from '../utils/utils';
import Loader from '../components/loader';
import { Link, NavLink, withRouter } from 'react-router-dom';
import DATE_FORMAT from '../components/constants/dateFormat';
import { Route } from 'react-router';
import MarketplaceAdminDeliveryDayCombined from './marketplaceAdminDeliveryDayCombined';
import MarketplaceAdminDeliveryDayIndividual from './marketplaceAdminDeliveryDayIndividual';
import MarketplaceAdminDeliveryDayBill from './marketplaceAdminDeliveryDayBill';

const MarketplaceAdminDeliveryDayMarketplace = ({ match, deliveryDayMarketplaces }) => {
  const deliveryDayMarketplace = deliveryDayMarketplaces.find(
    (deliveryDayMarketplace) => `${deliveryDayMarketplace.id}` === match.params.deliveryDayMarketplaceId
  );
  if (!deliveryDayMarketplace) {
    return <Loader />;
  }

  const deliveryDate = utils.getFormattedDateFromString(
    deliveryDayMarketplace.deliveryDate,
    DATE_FORMAT.displayWithTimeAndWeekday
  );

  return (
    <div className="marketplace-admin__orders">
      <div className="m-b-2">
        <Link to={`/marketplaceAdmin/${match.params.marketplaceId}`}>
          <FormattedMessage id={'marketplace.admin.delivery.day.orders.back'} />
        </Link>
      </div>

      <h3>
        <FormattedMessage
          id={'marketplace.admin.delivery.day.orders.header'}
          values={{
            deliveryDate: deliveryDate,
          }}
        />
      </h3>

      <ul className="list-unstyled list-inline m-b-3 p-a-0">
        <li className="list-inline-item">
          <NavLink className="link" exact to={`${match.url}`}>
            <FormattedMessage id={'marketplace.admin.delivery.day.links.order.items'} />
          </NavLink>
        </li>
        <li className="list-inline-item">
          <NavLink className="link" to={`${match.url}/individual`}>
            <FormattedMessage id={'marketplace.admin.delivery.day.links.orders'} />
          </NavLink>
        </li>
        {deliveryDayMarketplace.billToUsId ? (
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}/billToMembo`}>
              <FormattedMessage id={'marketplace.admin.delivery.day.links.bill.to.membo'} />
            </NavLink>
          </li>
        ) : (
          ''
        )}
        {deliveryDayMarketplace.billToSellerId ? (
          <li className="list-inline-item">
            <NavLink className="link" to={`${match.url}/billToSeller`}>
              <FormattedMessage id={'marketplace.admin.delivery.day.links.bill.to.seller'} />
            </NavLink>
          </li>
        ) : (
          ''
        )}
      </ul>

      <Route
        exact
        path={`${match.url}`}
        render={(props) => (
          <MarketplaceAdminDeliveryDayCombined
            deliveryDayMarketplace={deliveryDayMarketplace}
            deliveryDayMarketplaceId={match.params.deliveryDayMarketplaceId}
          />
        )}
      />

      <Route
        path={`${match.url}/individual`}
        render={(props) => (
          <MarketplaceAdminDeliveryDayIndividual deliveryDayMarketplaceId={match.params.deliveryDayMarketplaceId} />
        )}
      />

      <Route
        path={`${match.url}/billToMembo`}
        render={(props) => <MarketplaceAdminDeliveryDayBill billId={deliveryDayMarketplace.billToUsId} />}
      />

      <Route
        path={`${match.url}/billToSeller`}
        render={(props) => <MarketplaceAdminDeliveryDayBill billId={deliveryDayMarketplace.billToSellerId} />}
      />
    </div>
  );
};

MarketplaceAdminDeliveryDayMarketplace.propTypes = {};

MarketplaceAdminDeliveryDayMarketplace.defaultProps = {};

export default withRouter(MarketplaceAdminDeliveryDayMarketplace);
